export const campaignStatusChoices = [
  { id: 'draft', name: 'Draft' },
  { id: 'active', name: 'Active' },
  { id: 'paused', name: 'Paused' },
  { id: 'completed', name: 'Completed' },
]

export const sendMethodChoices = [
  { id: 'kernel', name: 'Kernel' },
  { id: 'lemlist', name: 'Lemlist' },
  { id: 'auto', name: 'Auto' },
]

export const campaignStatusColors = {
  draft: 'default',
  active: 'success',
  paused: 'warning',
  completed: 'info',
}

export const campaignLeadStatusColors = {
  pending: 'default',
  scheduled: 'info',
  sent: 'primary',
  opened: 'success',
  replied: 'success',
  bounced: 'error',
  failed: 'error',
}

export const sendMethodColors = {
  kernel: 'info',
  lemlist: 'warning',
  auto: 'default',
}
